import { Stack, Typography, SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import {
	titleSX,
	subtitleSX,
	titlecontactsSX,
	infoSX,
} from '@/components/blocks/DpLibrary/DpContact/Styles/main';
import { DpButtonPhone } from '@/components/blocks/DpLibrary/DpButtonPhone';
import { DpButtonWhatsApp } from '@/components/blocks/DpLibrary/DpButtonWhatsApp';
import { DpButtonEmail } from '@/components/blocks/DpLibrary/DpButtonEmail';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { combineSX } from '@/utils/combineSX';

// eslint-disable-next-line complexity
export const DpContact = ({
	title,
	subtitle,
	titlecontacts,
	titlecontactsmobile,
	labelphone,
	phonenumberwp,
	labelwhatsapp,
	linkwhatsapp,
	titlesecond,
	labelemail,
	email,
	info,
	background,
	sxcontainer,
	sxemail,
}: {
	title: string;
	subtitle: string;
	titlecontacts: string;
	titlecontactsmobile: string;
	labelphone: string;
	phonenumberwp: string;
	labelwhatsapp: string;
	linkwhatsapp: string;
	titlesecond: string;
	labelemail: string;
	email: string;
	info: string;
	background: string;
	sxcontainer?: SxProps;
	sxemail?: SxProps;
}) => {
	const isMobile = useIsMobile();

	return isMobile ? (
		<Box>
			<Stack sx={{ backgroundColor: background, py: '40px' }} direction={'column'} spacing={2}>
				<Stack sx={{ px: '15px' }}>
					{title ? (
						<Typography component={'h2'} sx={titleSX}>
							{title}
						</Typography>
					) : null}
				</Stack>
				<Stack sx={{ px: '15px' }}>
					{subtitle ? <Typography sx={subtitleSX}>{subtitle}</Typography> : null}
				</Stack>
				<Stack>
					{titlecontactsmobile ? (
						<Typography component={'h3'} sx={titlecontactsSX}>
							{titlecontactsmobile}
						</Typography>
					) : null}
				</Stack>
				<Stack direction={'column'} justifyContent={'center'} spacing={2} sx={{ px: '10%' }}>
					<DpButtonPhone label={labelphone} phoneNumber={phonenumberwp}></DpButtonPhone>
					<DpButtonWhatsApp label={labelwhatsapp} link={linkwhatsapp}></DpButtonWhatsApp>
				</Stack>
				<Stack sx={{ px: '15%' }}>
					{info ? <Typography sx={infoSX}>{info}</Typography> : null}
				</Stack>
				<Stack>
					{titlesecond ? (
						<Typography component={'h3'} sx={titlecontactsSX}>
							{titlesecond}
						</Typography>
					) : null}
				</Stack>
				<Stack
					direction={'column'}
					justifyContent={'center'}
					sx={combineSX([
						{ pl: '5%', pr: '5%' },
						...(Array.isArray(sxemail) ? sxemail : [sxemail]),
					])}
					spacing={2}
				>
					<DpButtonEmail label={labelemail} email={email}></DpButtonEmail>
				</Stack>
			</Stack>
		</Box>
	) : (
		<Box sx={combineSX([...(Array.isArray(sxcontainer) ? sxcontainer : [sxcontainer])])}>
			<Stack sx={{ backgroundColor: background, py: '40px' }} direction={'column'} spacing={1.5}>
				<Stack>
					{title ? (
						<Typography component={'h2'} sx={titleSX}>
							{title}
						</Typography>
					) : null}
				</Stack>
				<Stack sx={{ px: '23%' }}>
					{subtitle ? <Typography sx={subtitleSX}>{subtitle}</Typography> : null}
				</Stack>
				<Stack>
					{titlecontacts ? (
						<Typography component={'h3'} sx={titlecontactsSX}>
							{titlecontacts}
						</Typography>
					) : null}
				</Stack>
				<Stack direction={'row'} justifyContent={'center'} spacing={2}>
					<DpButtonPhone label={labelphone} phoneNumber={phonenumberwp}></DpButtonPhone>
					<DpButtonWhatsApp label={labelwhatsapp} link={linkwhatsapp}></DpButtonWhatsApp>
					<DpButtonEmail label={labelemail} email={email}></DpButtonEmail>
				</Stack>
				<Stack>{info ? <Typography sx={infoSX}>{info}</Typography> : null}</Stack>
			</Stack>
		</Box>
	);
};
